import React from 'react'
import { Form } from 'stylist'
import displayName from 'utils/displayName'

const Text = ({ field, key }) => (
  <Form.Group key={key}>
    <label>{field.label || displayName(field.name)}:</label>
    <Form.Input type={field.type} name={field.name} />
  </Form.Group>
)

export default Text



// WEBPACK FOOTER //
// ./src/components/fields/Text.js